import { useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuthContext } from "../../context/authContext";
import Navbar from "../navbar/Navbar";

const Login = ({M}) => {
    const  {isAuthenticated}  = useAuthContext();
    const [modalPreLogin, setModalPreLogin] = useState("");
    if (isAuthenticated) {
        return <Navigate to={"/cursos/"} />;
    } else {
        return (
            <>
            <Navbar M={M} setModalPreLogin={setModalPreLogin} />
            <Outlet />
            </>
        );
    }
};

export default Login;
